import React from "react";

const AddShopppingMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53.433"
      height="23.952"
      viewBox="0 0 53.433 23.952"
    >
      <g
        id="Raggruppa_1189"
        data-name="Raggruppa 1189"
        transform="translate(-36.129 -522)"
      >
        <g
          id="Raggruppa_1036"
          data-name="Raggruppa 1036"
          transform="translate(16.31 -57)"
        >
          <g
            id="Raggruppa_943"
            data-name="Raggruppa 943"
            transform="translate(0 3.996)"
          >
            <g
              id="Raggruppa_932"
              data-name="Raggruppa 932"
              transform="translate(-29)"
            >
              <path
                id="Tracciato_260"
                data-name="Tracciato 260"
                d="M2459.452,8628.048h5.3l2.231,16.49h16.159"
                transform="translate(-2383.5 -8052.044)"
                fill="none"
                stroke="#303130"
                stroke-linecap="round"
                stroke-width="2"
              />
              <path
                id="Tracciato_261"
                data-name="Tracciato 261"
                d="M2464.851,8630.967h19.9v7.624l-18.639,2.9"
                transform="translate(-2383.5 -8053.044)"
                fill="#303130"
                stroke="#303130"
                stroke-width="2"
              />
              <g
                id="Ellisse_45"
                data-name="Ellisse 45"
                transform="translate(83.5 594.956)"
                fill="#303130"
                stroke="#303130"
                stroke-width="1"
              >
                <circle cx="2" cy="2" r="2" stroke="none" />
                <circle cx="2" cy="2" r="1.5" fill="none" />
              </g>
              <g
                id="Ellisse_46"
                data-name="Ellisse 46"
                transform="translate(97.5 594.956)"
                fill="#303130"
                stroke="#303130"
                stroke-width="1"
              >
                <circle cx="2" cy="2" r="2" stroke="none" />
                <circle cx="2" cy="2" r="1.5" fill="none" />
              </g>
            </g>
            <line
              id="Linea_195"
              data-name="Linea 195"
              y2="5.787"
              transform="translate(62.619 579.708)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="1"
            />
            <line
              id="Linea_196"
              data-name="Linea 196"
              y2="5.787"
              transform="translate(65.512 582.602) rotate(90)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="1"
            />
          </g>
          <g
            id="Raggruppa_928"
            data-name="Raggruppa 928"
            transform="translate(-39.38 -56)"
          >
            <path
              id="Tracciato_258"
              data-name="Tracciato 258"
              d="M0,0,4.24,4.241,0,8.482"
              transform="translate(64.5 650.741) rotate(180)"
              fill="none"
              stroke="#303130"
              stroke-linecap="round"
              stroke-width="1.5"
            />
            <path
              id="Tracciato_259"
              data-name="Tracciato 259"
              d="M0,0,4.24,4.241,0,8.482"
              transform="translate(70.5 650.741) rotate(180)"
              fill="none"
              stroke="#303130"
              stroke-linecap="round"
              stroke-width="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AddShopppingMobile;
